import { Injectable } from '@angular/core';
import { XpWorkorderService } from "./xp-workorder.service";

@Injectable()

export class XpReportService {

  data: any = null;
  active = false;

  constructor(
      public workorderService: XpWorkorderService
  ) {}

  public getData(){
    console.log('XpReportService.getData');
    return this.data;
  }

  public setData(data){
    console.log('XpReportService.setData', data);
    this.active = true;
    this.data = data;
  }

  public clearData(){
    console.log('XpReportService.clearData');
    this.active = false;
    this.data = null;
  }

  public isActive(){
    return this.active;
  }

  public setActive(value){
    console.log('XpReportService.setActive: ' + value);
    this.active = value;
  }

  public save(){
    console.log('XpReportService.save');
    return new Promise((resolve, reject) => {
      if(this.data === null){
        resolve();
      }
      // Set list title
      this.data.list_title = this.getListTitle();
      this.data.list_subtitle = this.getListSubtitle();
      // Save
      this.workorderService.setWorkorder(this.data).then(() => {
        resolve();
      }).catch(() => {
        reject();
      })
    });
  }

  private getListTitle(){
    let list_title = '';
    if(this.data.workorder_nr) list_title += '[' + this.data.workorder_nr + '] ';
    if(this.data.customers.client.company){
      list_title += this.data.customers.client.company + ' ';
    } else {
      if(this.data.customers.client.firstname) list_title += this.data.customers.client.firstname + ' ';
      if(this.data.customers.client.lastname) list_title += this.data.customers.client.lastname;
    }
    if(this.data._selected_units && this.data._selected_units.length > 0 && this.data._selected_units[0].list_title){
      let unit = this.data._selected_units[0];
      if(list_title){
        list_title += ' - ';
      }
      list_title += unit.list_title;
    }
    list_title = list_title.trim();
    if(!list_title) list_title = 'Onbekende werkorder';
    return list_title;
  }

  private getListSubtitle(){
    let list_subtitle = '';
    if(this.data.location.street) list_subtitle += this.data.location.street + ' ';
    if(this.data.location.street) list_subtitle += this.data.location.number;
    if(this.data.location.zipcode){
      if(list_subtitle) list_subtitle += ', ';
      list_subtitle += this.data.location.zipcode;
    }
    if(this.data.location.city) {
      if(list_subtitle) list_subtitle += ', ';
      list_subtitle += this.data.location.city;
    }
    if(this.data._selected_units && this.data._selected_units.length > 0 && this.data._selected_units[0].list_subtitle){
      let unit = this.data._selected_units[0];
      if(list_subtitle){
        list_subtitle += ' - ';
      }
      list_subtitle += unit.list_subtitle;
    }
    list_subtitle = list_subtitle.trim();
    if(!list_subtitle) list_subtitle = 'Onbekende locatie';
    return list_subtitle;
  }

}



// WEBPACK FOOTER //
// ./src/services/xp-report.service.ts